import { ActivitiesDetailsEffects } from './activities-details.effects';
import { ActivitiesSearchEffects } from './activities-search.effects';
import { CarHireCategoriesEffects } from './car-hire-categories.effects';
import { CarHireDetailsEffects } from './car-hire-details.effects';
import { CarHireSearchEffects } from './car-hire-search.effects';
import { FlightsSearchEffects } from './flights-search.effects';
import { HotelAmenitiesEffects } from './hotel-amenities.effects';
import { HotelDetailsEffects } from './hotel-details.effects';
import { HotelMealBasisEffects } from './hotel-meal-basis.effects';
import { HotelRoomEffects } from './hotel-room.effects';
import { HotelSearchEffects } from './hotel-search.effects';
import { HotelSuppliersEffects } from './hotel-suppliers.effects';
import { TravelSearchFormEffects } from './travel-search-form.effects';

export const travelSearchEffects: any[] = [
  CarHireSearchEffects,
  CarHireDetailsEffects,
  CarHireCategoriesEffects,
  HotelAmenitiesEffects,
  HotelDetailsEffects,
  HotelSearchEffects,
  FlightsSearchEffects,
  HotelMealBasisEffects,
  HotelRoomEffects,
  HotelSuppliersEffects,
  ActivitiesSearchEffects,
  TravelSearchFormEffects,
  ActivitiesDetailsEffects,
];

export * from './activities-details.effects';
export * from './activities-search.effects';
export * from './car-hire-categories.effects';
export * from './car-hire-details.effects';
export * from './car-hire-search.effects';
export * from './flights-search.effects';
export * from './hotel-amenities.effects';
export * from './hotel-details.effects';
export * from './hotel-meal-basis.effects';
export * from './hotel-room.effects';
export * from './hotel-search.effects';
export * from './hotel-suppliers.effects';
